<div
  class="radio-group-container"
  [attr.data-size]="size"
  [attr.data-layout]="layout"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  (click)="!disabled && onRadioChange(value)"
  [attr.role]="'radio'"
  [attr.aria-checked]="checked"
  [attr.tabindex]="disabled ? -1 : 0"
>
  <umss-radio
    [value]="value"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    [error]="error"
    [size]="size"
    [ariaLabel]="computedAriaLabel"
    (checkedChange)="onRadioChange($event)"
  >
  </umss-radio>

  <div class="radio-group-content">
    <umss-label
      [text]="label"
      [required]="required"
      size="Regular"
      weight="Medium"
    >
    </umss-label>

    <p *ngIf="helperText" class="radio-group-helper">
      {{ helperText }}
    </p>
  </div>
</div>
